<mat-toolbar *ngIf="letter && !gameEndMode">
  <p>Words or Phrases must start with: {{ letter }}</p>
</mat-toolbar>

<div class="host-container scattergories-host-container">
  <div class="page-container">
    <div *ngIf="!voteMode && !submitMode && !gameEndMode">
      <h1>Welcome to the Scattergories Game!</h1>

      <h2>To Join the game, please connect using this room code: <strong>{{ gameId }}</strong></h2>

      <h2>Players go to <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a> on your favorite browser to join in on the fun!</h2>
    </div>

    <div *ngIf="gameEndMode">
      <h1>Game Over!</h1>
      <p></p>
      <h2>Scoreboard:</h2>

      <mat-list>
        <mat-list-item *ngFor="let user of connectedUsers; let i = index">
          <img matListAvatar src="{{ user.avatar }}">
          <h3 matLine>{{ user.name }} <span *ngIf="i === 0">- Winner!</span><span class="pull-right">Score: {{ user.currentScore }}</span></h3>

          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-list>

      <div class="game-over-btn-container">
        <button mat-raised-button color="primary" class="full-width" (click)="playAgain()">Play Again</button>
        <button mat-raised-button color="secondary" class="full-width" (click)="playAgain(false)">Choose Another Game</button>
      </div>
    </div>

    <div *ngIf="voteMode || submitMode">
      <mat-list>
        <div *ngFor="let cat of categories">
          <mat-list-item>{{ cat }}</mat-list-item>
          <mat-divider></mat-divider>
        </div>
      </mat-list>
    </div>

    <div class="connected-users" *ngIf="showUsers && !gameEndMode">
      <div class="user-list-container">
        <ul class="user-list">
          <li *ngFor="let connectedUser of connectedUsers">
            <img class="avatar" src="{{ connectedUser.avatar }}">
            <p class="username"><strong>{{ connectedUser.name }}</strong></p>
            <p class="score" [hidden]="!connectedUser.currentScore || connectedUser.currentScore === 0" [style.height]="(connectedUser.currentScore / 2) + 'vh'">
              <strong>{{ connectedUser.currentScore }}</strong>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
